import {
  MsgL2Type,
  ReplyMsg,
  MsgL3Type,
  VideoInfo,
  PicInfo,
  FileInfo,
  AudioInfo,
  C2CMsg,
  AtMsg,
  SignalingMsg,
  ChannelMsg,
  CardInfoMsg,
  SystemMsg,
  StickerMsg,
  InteractionMsg,
  ReactionList,
  MixedMsg,
  BotData,
  ForwardMsg,
  RoleCardMsg,
  ReportParameters,
  GraffitiMsg,
  StructuredMsg,
  InternalParameters,
  MsgTopicData,
  TopicStructuredMsg,
  CustomStructuredMsg,
} from '../../proto/';
import { ISimpleUser } from '../user';
import * as im_common from '../../proto/im_common.proto';
import * as user_common from '../../proto/user_common.proto';
import TIM from 'tim-js-sdk';
import { RecursivePartial } from '../../util';

/** 回调函数列表 */
export type TEventCallbackList = {
  [key: string]: Array<
  TEventCallbackString
  |TEventCallbackMsgList
  |TEventCallbackMsg
  |TEventCallbackNetworkStatusChange
  |TEventCallbackKickedOut
  >;
};

/** 回调函数类型 */
export type TEventCallbackString = (data: string) => void | Promise<void>;

export type TEventCallbackMsgList = (data: Array<IMsg>) => void | Promise<void>;

export type TEventCallbackMsg = (data: IMsg) => void | Promise<void>;

// export type TEventCallbackLoginStatusChange = (data: NetworkStatus) => void;

export type TEventCallbackNetworkStatusChange = (event: NetStateChangeEvent) => void | Promise<void>;

export type TEventCallbackKickedOut = (event: KickedOutEvent) => void | Promise<void>;

export type TEventCallback =
  TEventCallbackString
  | TEventCallbackMsgList
  | TEventCallbackMsg
  // | TEventCallbackLoginStatusChange
  | TEventCallbackNetworkStatusChange
  | TEventCallbackKickedOut;

/** 消息发送前的预处理函数 */
export type TPreHandle = (msg: IMsg) => Promise<IMsg>;

export type TGetMessageTraceInfo = {
  getMessageTime: number,
  formatMessageTime: number,
  addUserInfoTime: number,
  getReactionTime?: number,
  newAddUserInfoTime?: number,
};

/** 历史消息返回数据类型 */
export type GetMessageListRsp = {
  messageList: Array<IMsg>;
  isCompleted: boolean;
  nextReqMessageID: string;
  isFromDB?: boolean;
  traceInfo?: TGetMessageTraceInfo;
};

export enum SendStatusType {
  init,
  preHandle, // 发送前的处理，比如图片、视频的上传
  loading,
  success,
  error
}

export type PicFileInfo = {
  file: File,
};

/** 解码后的消息体 */
export interface IMsg{
  /** 普通消息/控制消息 */
  type: im_common.MsgType;
  /** 消息内容类型 */
  l2Type: im_common.MsgL2Type;
  /** 消息类型 */
  l3Types: Array<im_common.MsgL3Type>;
  /** 消息范围,单聊/channel/group */
  scope: im_common.MsgScope;
  /** 时间戳;注意,这里不能信任终端时间戳 */
  ts: string;
  /** 发送方uid */
  senderUid: string;
  /** 内容 */
  content: string;
  /** 视频数据 */
  videoInfo: Array<im_common.VideoInfo>;
  /** 图片数据 */
  picInfo: Array<im_common.PicInfo>;
  /** 文件数据 */
  fileInfo: Array<im_common.FileInfo>;
  /** 语音数据 */
  audioInfo: Array<im_common.AudioInfo>;
  /** 单聊消息结构 */
  c2cMsg?: im_common.C2CMsg;
  /** channel消息结构 */
  channelMsg: im_common.ChannelMsg;
  /** 回复消息 */
  replyMsg?: im_common.ReplyMsg;
  /** at消息 */
  atMsg?: RecursivePartial<im_common.AtMsg>;
  /** 信令消息 */
  signalingMsg?: im_common.SignalingMsg;
  /** 消息摘要 */
  desc?: string;
  /** 卡片消息 */
  cardInfo: Array<im_common.CardInfoMsg>;
  /** 系统消息 */
  systemMsg?: im_common.SystemMsg;
  /** 表情消息 */
  stickerMsg?: im_common.StickerMsg;
  /** 互动类消息 */
  interactionMsg: Array<InteractionMsg>;
  /** 混合消息,目前只用于存储顺序 */
  mixedMsg?: im_common.MixedMsg;
  /** 机器人相关数据 */
  botData?: im_common.BotData;
  /** 消息版本,编辑消息用 */
  version: string;
  /** 转发消息 */
  forwardMsg?: im_common.ForwardMsg;
  /** 角色卡消息 */
  roleCardMsg?: im_common.RoleCardMsg;
  /** 上报相关参数 */
  reportParams?: im_common.ReportParameters;
  /** 涂鸦消息 */
  graffitiMsg?: im_common.GraffitiMsg;
  /** 结构化消息 */
  structuredMsg?: im_common.StructuredMsg;
  /** 内部参数 */
  internalParams?: im_common.InternalParameters;
  /** 消息话题数据 */
  msgTopicData?: im_common.MsgTopicData;
  /** 话题结构化消息 */
  topicStructuredMsg?: im_common.TopicStructuredMsg;
  /** 自定义消息 */
  customMsg?: im_common.CustomStructuredMsg;
  /** 业务平台信息 */
  busiPlatform: im_common.BusinessPlatform;
  /** 消息状态(自研使用) */
  msgStatus?: never;
  /** 唯一id,用于发送方可重入发消息使用(自研使用) */
  sameMsgCheckInfo?: never;
  /** 消息id(自研使用) */
  messageId?: string;
  /** 是否需要计入未读消息数(自研使用) */
  needUnreadNum?: boolean;
  /** 消息接收者信息(自研使用) */
  msgReceiveInfo?: im_common.MsgReceiveInfo;
  /** 摘要相关数据,content和desc在外层 */
  templateData?: im_common.MsgTemplateData;
  /** 平台基础信息 */
  platformBasedInfo?: im_common.PlatformBasedInfo;
  /** 内容链接信息 */
  contentLinkMsg?: RecursivePartial<im_common.ContentLinkInfo>;

  /** 以上为后台结构数据 **/

  /** 以下为自定义结构数据 **/
  senderUserInfo?: ISimpleUser;// 发送者信息，由业务侧自己填充
  origin?: TTimMsg; // 原始数据
  sendStatus: SendStatusType;
  clientId?: string;
  reportId: string;
  reactions?: ReactionList;
  picFileInfo?: PicFileInfo;
  code?: number;
  // 是否需要合并
  needMerge?: boolean;
  mergeSendTime?: number;
  // 消息唯一标示，优先使用 origin.ID，如果没有就自动生成一个
  id?: string;
  // 精华消息所属标签
  tagInfo?: Array<im_common.ImTagESElem>;
  // 设置精华消息时间
  collectorConfigTime?: number;
  // 设置精华消息用户
  collectorConfigUser?: user_common.UserInfoBase;
  // 合并系统精华消息
  needCollectorMsg?: Array<IMsg>;
}

/** im的原始消息体 */
export type TTimMsg = {
  ID: string,
  payload: TTimMsgPayload,
  sequence: number,
  isRevoked: boolean,
  time: number,
  message?: IMsg,
};

export type TTimMsgPayload = {
  data: string
};

/** 会话信息 */
export type TConversation = {
  lastMessage: IMsg | null,
  unreadCount: number
};

/** 未读@消息 */
export type TUnReadAtCount = {
  atAll: TUnReadCount,
  atMe: TUnReadCount
};

/** 未读数 */
export type TUnReadCount = {
  [key: string]: number
};

/** im事件 */
export interface IBaseEvent {
  name: string
}

/** 收到新消息事件 */
export interface MessageReceivedEvent extends IBaseEvent{
  data: Array<TTimMsg>
}

export interface INetStateData {
  state: string;
}

/** 网络状态发生变化 */
export interface NetStateChangeEvent extends IBaseEvent{
  data: INetStateData;
}

export interface IKickedOutData {
  type: TIM.TYPES.KICKED_OUT_MULT_ACCOUNT | TIM.TYPES.KICKED_OUT_MULT_DEVICE | TIM.TYPES.KICKED_OUT_USERSIG_EXPIRED;
}

/** 被踢下线 */
export interface KickedOutEvent extends IBaseEvent{
  data: IKickedOutData;
}

/** 基础消息类型 */
export interface IBaseMessage {
  /** 消息内容类型 */
  l2Type: MsgL2Type;
  /** 消息类型 */
  l3Types?: Array<MsgL3Type>;
  /** 内容 */
  content?: string;
  /** 视频数据 */
  videoInfo?: Array<VideoInfo>;
  /** 图片数据 */
  picInfo?: Array<PicInfo>;
  /** 文件数据 */
  fileInfo?: Array<FileInfo>;
  /** 语音数据 */
  audioInfo?: Array<AudioInfo>;
  /** 单聊消息结构 */
  c2cMsg?: C2CMsg;
  /** channel消息结构 */
  channelMsg?: ChannelMsg;
  /** 回复消息 */
  replyMsg?: ReplyMsg;
  /** at消息 */
  atMsg?: RecursivePartial<AtMsg>;
  /** 信令消息 */
  signalingMsg?: SignalingMsg;
  /** 消息摘要 */
  desc?: string;
  /** 卡片消息 */
  cardInfo?: Array<CardInfoMsg>;
  /** 系统消息 */
  systemMsg?: SystemMsg;
  /** 表情消息 */
  stickerMsg?: StickerMsg;
  /** 互动类消息 */
  interactionMsg?: Array<InteractionMsg>;
  /** 混合消息,目前只用于存储顺序 */
  mixedMsg?: MixedMsg;
  /** 机器人相关数据 */
  botData?: BotData;
  /** 消息版本,编辑消息用 */
  version?: string;
  /** 转发消息 */
  forwardMsg?: ForwardMsg;
  /** 角色卡消息 */
  roleCardMsg?: RoleCardMsg;
  /** 上报相关参数 */
  reportParams?: ReportParameters;
  /** 涂鸦消息 */
  graffitiMsg?: GraffitiMsg;
  /** 结构化消息 */
  structuredMsg?: StructuredMsg;
  /** 内部参数 */
  internalParams?: InternalParameters;
  /** 消息话题数据 */
  msgTopicData?: MsgTopicData;
  /** 话题结构化消息 */
  topicStructuredMsg?: TopicStructuredMsg;
  /** 自定义消息 */
  customMsg?: CustomStructuredMsg;
  /** 内容链接信息 */
  contentLinkMsg?: RecursivePartial<im_common.ContentLinkInfo>;
}

/** 文本消息 */
export interface ITextMessage extends IBaseMessage{
  content: string
}

/** 视频消息 */
export interface IVideoMessage extends IBaseMessage{
  videoInfo: Array<VideoInfo>
}

/** 表情包消息 */
export interface IStickerMessage extends IBaseMessage{
  stickerMsg: StickerMsg
}


/** 表情包消息 */
export interface IPicMessage extends IBaseMessage{
  /** 图片数据 */
  picInfo?: Array<PicInfo>;
  picFileInfo?: PicFileInfo;
}

export interface IForwardMessage extends IBaseMessage {
  forwardMsg: ForwardMsg
}
